import React from 'react';
import { GetServerSideProps, InferGetServerSidePropsType } from 'next';
import Head from 'next/head';

import _config from 'config';
import Developers from 'src/components/Developers';

type Props = {
    locals: { siteUrl: string; pageSize: number };
};

export const getServerSideProps: GetServerSideProps<Props> = async () => {
    const locals = {
        siteUrl: _config.SITE_HOST,
        pageSize: _config.PAGE_SIZE,
    };
    return { props: { locals } };
};

export default function Page({ locals }: InferGetServerSidePropsType<typeof getServerSideProps>) {
    return (
        <>
            <Head>
                <meta charSet="UTF-8" />
                <title>Bioclinica Portal API</title>
                <meta httpEquiv="X-UA-Compatible" content="IE=edge,chrome=1" />
                <meta name="description" content="Documentația tehnică a proiectului Bioclinica Portal API" />
                <meta
                    name="viewport"
                    content="width=device-width, user-scalable=no, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0"
                />
            </Head>
            <div id="app">
                <Developers locals={locals} />
            </div>
        </>
    );
}
